
import React from 'react';
import { Clock, MapPin, Users, Star } from 'lucide-react';

const TourQuickInfoBar: React.FC = () => {
  return (
    <section className="bg-[#F5EDE0] py-4 border-b border-[#C58B65]/20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-3 text-[#3E2723]">
          <div className="flex items-center">
            <Clock size={18} className="mr-2 text-[#C58B65]" />
            <span className="text-sm md:text-base">2 hours</span>
          </div>
          <div className="flex items-center">
            <MapPin size={18} className="mr-2 text-[#C58B65]" />
            <span className="text-sm md:text-base">1.5 miles of walking</span>
          </div>
          <div className="flex items-center">
            <Users size={18} className="mr-2 text-[#C58B65]" />
            <span className="text-sm md:text-base">Small groups (max 12 people)</span>
          </div>
          <div className="flex items-center">
            <Star size={18} className="mr-2 text-[#D4AF37]" />
            <span className="text-sm md:text-base">98% 5-star reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourQuickInfoBar;
